<script>
  export let data;
  export let id;

  let { label, handlemodal, handleCollapse } = data;
  function handleClick(e) {
    e.preventDefault();
    handlemodal(e, id);
  }
  function handleClose() {
    handleCollapse(label);
  }

  function handleKeyDown(event) {
    if (event.key === "Enter" || event.key === " ") {
      handleClick(event);
    }
  }
  $$restProps;
</script>

<div class="container">
  <div data-node-id={id} class="group-node">
    <span
      style="font-weight: bold; font-size: 18px; display: block; max-width: 100%; word-break: normal; white-space: normal; text-align: center; overflow-wrap: break-word;"
      on:click={handleClick}
      on:keydown={handleKeyDown}>{@html label}</span
    >
    <div class="button-collapse">
      <!-- <button on:click={handleClick}>
        <img
          alt="icon button"
          class="more_filled_icon undefined"
          src="/img/ui_icons/more.svg"
          width="30"
          height="30"
        />
      </button> -->
      <button on:click={handleClose}>
        <img
          alt="icon button"
          class="more_filled_icon undefined"
          src="/img/ui_icons/collapse.svg"
          width="30"
          height="30"
        />
      </button>
    </div>
  </div>
</div>

<style>
  .group-node {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding-left: 70px; /* Balance the padding for buttons to center text */
    padding-right: 70px; /* Space for buttons */
    box-sizing: border-box; /* Ensure padding is included in width */
  }
  .container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
  }
  .button-collapse {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    gap: 5px;
  }
</style>
